import React from 'react';

import classNames from 'classnames';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	message?: string;
	children?: React.ReactNode;
}

export default function InfoMessage({ message, children, className, ...props }: Props) {
	const content = message || children;
	if (!content) return null;

	return (
		<div className={classNames('text-xs text-gray-500 font-sans', className)} {...props}>
			{content}
		</div>
	);
}
